import React, { useEffect, useState } from 'react';

const ImageCarousel = ({ images }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (images !== undefined && images !== null) {
      setLoading(false);
    }
  }, [images]);

  return (
    <div className='relative flex justify-center items-center'>
      {loading ? (
        <div className='flex justify-center items-center p-4'>
          <div className='animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-500'></div>
        </div>
      ) : images && images.length > 0 ? (
        <img
          src={images[0].image.secure_url}
          alt='headerImage'
          className='w-full object-cover h-auto sm:h-[90vh]'
        />
      ) : (
        <h1 className='text-center'>Image Not Available</h1>
      )}
    </div>
  );
};

export default ImageCarousel;
